import type { JSX } from "react";

import type { SectionRenderInput } from "./types";

/**
 * FIND IT — the venue directory, every verified row with the links it has. A
 * venue contributes only what the location record carries: a bare row prints its
 * name and nothing else rather than a placeholder for each missing field.
 *
 * `section.limit` caps the list, and unset means the whole directory: this block
 * is a directory, not a teaser.
 */
export function VenuesSection({ section, page }: SectionRenderInput): JSX.Element {
  const venues = page.venues.slice(0, section.limit ?? page.venues.length);
  return (
    <ul className="atlas-guide-venues">
      {venues.map((venue) => (
        <li key={venue.name} className="bg-ink p-5">
          <p className="font-anton text-[clamp(1.1rem,2.5vw,1.6rem)] uppercase leading-none text-paper">
            {venue.name}
          </p>
          {venue.neighborhood && (
            <p className="pt-2 font-mono text-[0.75rem] font-semibold uppercase tracking-wider text-paper-muted">
              {venue.neighborhood}
            </p>
          )}
          <div className="flex flex-wrap gap-x-4 gap-y-2 pt-3 font-mono text-[0.75rem] font-semibold tracking-wider">
            {venue.website && (
              <a
                href={venue.website}
                target="_blank"
                rel="noreferrer"
                className="text-paper-header underline decoration-accent underline-offset-4 transition-colors hover:text-accent"
              >
                WEBSITE
              </a>
            )}
            {venue.instagramHandle && (
              <a
                href={`https://instagram.com/${venue.instagramHandle}`}
                target="_blank"
                rel="noreferrer"
                className="text-paper-header underline decoration-accent underline-offset-4 transition-colors hover:text-accent"
              >
                @{venue.instagramHandle.toUpperCase()}
              </a>
            )}
            {venue.mapsUrl && (
              <a
                href={venue.mapsUrl}
                target="_blank"
                rel="noreferrer"
                className="text-paper-header underline decoration-accent underline-offset-4 transition-colors hover:text-accent"
              >
                MAP
              </a>
            )}
          </div>
          {(venue.phone || venue.rating != null) && (
            <p className="pt-2 font-mono text-[0.75rem] font-semibold tracking-wider text-paper-muted">
              {venue.rating != null && `${venue.rating.toFixed(1)} · `}
              {venue.phone}
            </p>
          )}
        </li>
      ))}
    </ul>
  );
}
